import React from "react";
import { Tabs } from "antd";
import General from "./Tabs/General";
import Landing from "./Tabs/Landing";
import Accounts from "./Tabs/Accounts";

const Settings = () => {
  const items = [
    {
      key: "1",
      label: "Account",
      children: <Accounts />,
    },
    {
      key: "2",
      label: "General",
      children: <General />,
    },
    {
      key: "3",
      label: "Landing",
      children: <Landing />,
    },
  ];

  return (
    <div className="setting_container">
      <h1 className="pageHeading">Settings</h1>
      <div>
        <Tabs defaultActiveKey="1" items={items} />
      </div>
    </div>
  );
};

export default Settings;
